// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__25J-X","buttons":"SendReceipts_buttons__2o6k4","email":"SendReceipts_email__1facB","bookApptTitle":"SendReceipts_bookApptTitle__2BGbd"};